// extracted by mini-css-extract-plugin
export const slideContainer = "singleSlide-module--slideContainer--1IMQz";
export const textContainer = "singleSlide-module--textContainer--3DQ_H";
export const slideTitle = "singleSlide-module--slideTitle--29vn6";
export const slideDescription = "singleSlide-module--slideDescription--k0AbN";